import { NgModule } from '@angular/core';

import { AuthModule } from './auth/auth.module';
import { AboutModule } from './about/about.module';
import { HelpAndContactsModule } from './help-and-contacts/help-and-contacts.module';
import { ConsultantOverviewModule } from './consultant-overview/consultant-overview.module';
import { OverviewModule } from './overview/overview.module';
import { PerformanceModule } from './performance/performance.module';
import { HoldingsModule } from './holdings/holdings.module';
import { CashFlowModule } from './cash-flow/cash-flow.module';
import { TransactionsModule } from './transactions/transactions.module';
import { StatementsModule } from './statements/statements.module';
import { DocumentsModule } from './documents/documents.module';
// import { ToasterModule } from './toaster/toaster.module';
import { ProfileModule } from './profile/profile.module';
import { ReportsModule } from './reports/reports.module';
import { MssoBypassModule } from './msso-bypass/msso-bypass.module';
import { SessionComponent } from './auth/session/session.component';
import { PrivacyModule } from './privacy/privacy.module';
import { ValuationsModule } from './valuations/valuations.module';
import { TermsOfUseModule } from './terms-of-use/terms-of-use.module';
import { DisclaimersModule } from './disclaimers/disclaimers.module';
import { EffectsModule } from '@ngrx/effects';
import { FeatureEffects } from './features.effects';
import { EsgModule } from './esg/esg.module';
import { TaxDetailsModule } from './tax-details/tax-details.module';
import { MenuModule } from 'atlas-menu';
import { ListModule } from 'atlas-list';
import { LinkModule } from 'atlas-link';
import { NavigationMenuModule } from 'atlas-navigation';

const MODULES = [
  AuthModule,
  AboutModule,
  HelpAndContactsModule,
  ConsultantOverviewModule,
  OverviewModule,
  PerformanceModule,
  HoldingsModule,
  EsgModule,
  CashFlowModule,
  TransactionsModule,
  StatementsModule,
  DocumentsModule,
  // ToasterModule,
  ProfileModule,
  ReportsModule,
  MssoBypassModule,
  PrivacyModule,
  ValuationsModule,
  TermsOfUseModule,
  DisclaimersModule,
  EffectsModule.forFeature([FeatureEffects]),
  TaxDetailsModule,
  MenuModule,
  ListModule,
  LinkModule,
  NavigationMenuModule
];

@NgModule({
  declarations: [],
  imports: MODULES,
  exports: [
    // ToasterModule,
    SessionComponent,
    PrivacyModule
  ],
  providers: [],
  bootstrap: [],
})
export class FeaturesModule { }




